export default __webpack_public_path__ + "static/media/CheckCircle(1).cbd2b11c.svg";